export default [

    {
        path: 'cajas',
        name: 'cajaSucursalesList',
        component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/sucursales/cajas/SucursalCajaList.vue'),

    },


   
    {
        path: "cajas/:cajaId/arqueos/:arqueoId/detalle",
        name: "cajaArqueoDetalle",
        component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/sucursales/cajas/SucursalCajaArqueoDetail.vue')

    },

    {
        path: "cajas/:cajaId",

        name: 'cajaSucursalesListDetalle',
        component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/sucursales/cajas/SucursalCajaArqueoList.vue'),

    },

    {
        path: "cajas/:cajaId/edit",

        name: 'cajaSucursalesEditar',
        component: () => import(/* webpackChunkName: "about" */ '@/views/empresa/sucursales/cajas/SucursalCajaEdit.vue'),

    },


];
